<div class="error-msg">
  <mat-icon class="error-msg__icon" [svgIcon]="icon"></mat-icon>
  <div class="error-msg__text-wrap">
    <h3 class="body-1" [innerHtml]="header"></h3>
    <p class="body-7" [innerHtml]="text"></p>
  </div>
  <mat-icon *ngIf="isShowCloseBtn" class="error-msg__close" (click)="close()">close</mat-icon>
</div>
